import type { JSX } from 'react';
import React from 'react';

import DonationFormsTable from './DonationFormsTable';

function FundraisingDashboard(): JSX.Element {
  return (
    <div>
      <DonationFormsTable />
    </div>
  );
}

export default FundraisingDashboard;
